// src/pages/ReglesEcole.js
import React, { useState, useEffect } from 'react';
import { db } from '../services/firebase';
import { doc, getDoc } from 'firebase/firestore';

// Contenu géré depuis l'admin panel (page "Règles de l'école") — même
// document Firestore que celui affiché dans le profil de l'app mobile.
function ReglesEcole() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const snap = await getDoc(doc(db, 'site_content', 'schoolRules'));
        if (snap.exists()) setContent(snap.data());
      } catch (err) {
        console.error('Erreur chargement règlement:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchRules();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '80px 20px', textAlign: 'center', color: '#666' }}>
        Chargement...
      </div>
    );
  }

  if (!content || !content.rules || content.rules.length === 0) {
    return (
      <div style={{ padding: '80px 20px', textAlign: 'center', color: '#666' }}>
        Le règlement sera bientôt disponible.
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '60px 24px 100px' }}>
      <h1 style={{ fontSize: 32, marginBottom: 16, color: '#1a1a1a' }}>
        {content.title || "Règlement de l'école"}
      </h1>
      {content.intro && (
        <p style={{ fontSize: 16, color: '#555', marginBottom: 32, lineHeight: 1.6 }}>
          {content.intro}
        </p>
      )}
      <ol style={{ paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 16, margin: 0 }}>
        {content.rules.map((rule, i) => (
          <li key={i} style={{ fontSize: 16, lineHeight: 1.6, color: '#333' }}>
            {rule}
          </li>
        ))}
      </ol>
    </div>
  );
}

export default ReglesEcole;
